<div class="row">
  <div class="col-3 grp-l">
    <button class="btn btn-move"
            [disabled]="atMin||disabled"
            [ngClass]="{'btn-primary':!(atMin||disabled),'btn-outline-secondary':atMin||disabled}"
            (click)="move(-step)">
      <i class="fa fa-minus"></i>
    </button>
  </div>
  <div class="col-6 text-center" [class.disabled]="disabled">
    <!-- <h4>{{value}}</h4> -->
    <select [(ngModel)]="value"
            (ngModelChange)="fireChange()"
            class="form-control text-center">
      <option *ngFor="let v of numbers" [value]="v">{{v}}</option>
    </select>
  </div>
  <div class="col-3 grp-r">
    <button class="btn btn-move"
            [disabled]="atMax||disabled"
            [ngClass]="{'btn-primary':!(atMax||disabled),'btn-outline-secondary':atMax||disabled}"
            (click)="move(step)">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>
